/**
 * Authentication helpers
 * JWT access token is cookie-based and never stored in localStorage.
 */
const DEV_CEA_STORAGE_KEY = 'dev_cea';

export function getDevCea(): string | null {
  try {
    return localStorage.getItem(DEV_CEA_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to get dev CEA from storage:', error);
    return null;
  }
}

export function setDevCea(ceaNumber: string): void {
  try {
    localStorage.setItem(DEV_CEA_STORAGE_KEY, ceaNumber);
  } catch (error) {
    console.error('Failed to store dev CEA:', error);
  }
}

export function clearDevCea(): void {
  try {
    localStorage.removeItem(DEV_CEA_STORAGE_KEY);
  } catch (error) {
    console.error('Failed to clear dev CEA:', error);
  }
}
